import React, { useState } from "react";
import { Form, Input, Button, message, Card } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { supabase } from "../supabase";

const StudentAuth = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { familyId } = useParams();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Verify the family exists and the code matches
      const { data, error } = await supabase
        .from("students")
        .select("*")
        .eq("family_id", familyId)
        .eq("access_code", values.code)
        .single();

      if (error) throw error;

      console.log(values.code);

      if (data.access_code == values.code) {
        console.log("Code verified");
        // Store the familyId in localStorage for future use
        localStorage.setItem("studentFamilyId", familyId);
        localStorage.setItem("studentId", data.id);
        localStorage.setItem("isStudent", "true");
        navigate(`/student/${familyId}/dashboard`);
      } else {
        message.error("Invalid code");
      }
    } catch (error) {
      message.error("Error verifying code");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <Card title="Student Access" style={{ width: 300 }}>
        <Form onFinish={onFinish}>
          <Form.Item
            name="code"
            rules={[
              { required: true, message: "Please input your access code!" },
              { len: 4, message: "Code must be 4 digits!" },
            ]}
          >
            <Input.Password placeholder="Enter 4-digit code" maxLength={4} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Enter
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default StudentAuth;
